/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} That_Main_Loris_AcceptInputs */

const fr_that_main_loris_accept = /** @type {(inputs: That_Main_Loris_AcceptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annuler`)
};

/**

* @param {That_Main_Loris_AcceptInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const that_main_loris_accept = /** @type {((inputs?: That_Main_Loris_AcceptInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<That_Main_Loris_AcceptInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_that_main_loris_accept(inputs)
});